import Epic from "@components/Epic";
import ConfirmationDialog from "@hudson/ui/components//Dialogs/Confirmation";
import Button from "@hudson/ui/components/FormFields/Button";
import FrameConfig from "@lib/classes/FrameConfig";
import Session from "@lib/session";
import useContent from "@lib/use_content";
import { useRouter } from "next/navigation";
import { useState } from "react";
import DebugProfiles from "./DebugProfiles";

function Edit({ className = "" }: { className?: string }): JSX.Element | null {
  const router = useRouter();
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const { data, loading } = useContent([
    "beConfirmDialogDefaultCancelButton",
    "beConfirmDialogDefaultTitle",
    "beEditBackButton",
    "beEditResidPrefix",
    "beEditStopDialogConfirmButton",
    "beEditStopDialogConfirmMessage",
  ]);

  async function cancelEdit() {
    await Session.clearBookingData(true);
    new FrameConfig().apply(); // Resets service area in case that got changed.
    router.push(`/${window.siteId}/res_summary`);
  }

  return loading ? null : (
    <>
      <header className={`${className} relative mb-8 -mt-2 xxs:-mt-4`}>
        <nav aria-label="Top" className="mx-auto">
          <DebugProfiles />
          <div>
            <div className="flex flex-wrap justify-between">
              <Epic className="self-start mt-3 mb-1 mr-2 text-slate-600" />

              <div className="flex flex-wrap items-center justify-end my-2 space-x-12 text-slate-600 ">
                <div>
                  {data?.content.beEditResidPrefix}{" "}
                  <span
                    style={{
                      color: "var(--primary-color)",
                    }}
                    className="font-extrabold"
                  >
                    {Session.getBooking()?.legs[0]?.resId}
                  </span>
                </div>

                <div>
                  <Button
                    onClick={() => setShowCancelConfirm(true)}
                    textColorClass="text-gray-500"
                    asLink
                    color="red"
                  >
                    <div className="flex space-x-2 hover:opacity-50">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <span>{data.content.beEditBackButton}</span>
                    </div>
                  </Button>
                </div>

                <ConfirmationDialog
                  cancelLabel={data?.content.beConfirmDialogDefaultCancelButton}
                  confirmLabel={data?.content.beEditStopDialogConfirmButton}
                  message={data?.content.beEditStopDialogConfirmMessage}
                  onConfirm={cancelEdit}
                  onHide={() => setShowCancelConfirm(false)}
                  show={showCancelConfirm}
                  title={data?.content.beConfirmDialogDefaultTitle}
                />
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Edit;
